export default "__VITE_ASSET__DucsuaRI__"